import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const ispuiSwitcherButtonCss = ".ispui-switcher__button{position:relative;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;height:var(--ispui-switcher__button-height, 35px);padding:var(--ispui-switcher__button-padding, 0 10px);cursor:pointer;color:var(--isp-text-main);border:var(--ispui-switcher__button-border, 1px solid var(--isp-border-default));border-left:none;background:var(--ispui-switcher__button-bg, var(--isp-background-additional))}.ispui-switcher__button:hover{background:var(--ispui-switcher__button-bg-hover, transparent)}.ispui-switcher__button:focus{z-index:1}.ispui-switcher__button_disabled{pointer-events:none;opacity:0.5}.ispui-switcher__button_disabled:last-child.ispui-switcher__button_disabled{border-right:var(--ispui-switcher__button-border, 1px solid var(--isp-border-default));border-left:none}.ispui-switcher__button:first-child,.ispui-switcher__button_first{border-left:var(--ispui-switcher__button-border, 1px solid var(--isp-border-default));border-radius:var(--ispui-switcher__br, 3px) 0 0 var(--ispui-switcher__br, 3px)}.ispui-switcher__button:last-child,.ispui-switcher__button_last{border-radius:0 var(--ispui-switcher__br, 3px) var(--ispui-switcher__br, 3px) 0}.ispui-switcher__button_selected{cursor:default;background:var(--ispui-switcher__button-bg_selected, var(--isp-background-list))}.ispui-switcher__button_selected:hover{background:var(--ispui-switcher__button-bg_selected-hover, var(--isp-background-list))}";

const IspuiSwitcherOption$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.disabled = false;
    this.selected = false;
    this.focusable = false;
  }
  render() {
    return (h(Host, Object.assign({ tabindex: this.focusable ? 0 : -1, role: "option" }, (!this.disabled ? { 'area-selected': this.selected } : {}), { class: {
        'ispui-switcher__button': true,
        'ispui-switcher__button_selected': this.selected,
        'ispui-switcher__button_disabled': this.disabled,
      } }), h("slot", null)));
  }
  static get style() { return ispuiSwitcherButtonCss; }
}, [1, "ispui-switcher-option", {
    "disabled": [4],
    "selected": [516],
    "focusable": [4],
    "skey": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["ispui-switcher-option"];
  components.forEach(tagName => { switch (tagName) {
    case "ispui-switcher-option":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, IspuiSwitcherOption$1);
      }
      break;
  } });
}

const IspuiSwitcherOption = IspuiSwitcherOption$1;
const defineCustomElement = defineCustomElement$1;

export { IspuiSwitcherOption, defineCustomElement };
